import Header from "../../components/Header/Header";
import { Container, Content, DivCenter} from "./styles";
import Lottie from "react-lottie";
import animationData from "../../assets/lotties/404.json";
import { useHistory } from "react-router-dom";
import { IoMdArrowRoundBack } from 'react-icons/io';

function Success() {
  const history = useHistory();
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      <Header />
      <Container>
        <Content>
        <div>
          <Lottie options={defaultOptions} width={140} />
        </div>
        <div>
          <h3>Ooops!</h3>
          <p>Nos desculpe esta</p>
          <p>página está indisponível!</p>
          <DivCenter>
          <button
              type="submit"
              onClick={() => {history.push("/lojasedmil.com.br")}}
            >
              <IoMdArrowRoundBack className="back"/> 
              <p>Voltar</p>
            </button>
          </DivCenter>
        </div>
        </Content>
      </Container>
    </>
  );
}

export default Success;
